import Layout from '@/modules/layout/components/layout';
import Permissions from '@/security/permissions';
import { storeAsync } from '../../app-module';
const CategoryRegistersList = () => import('@/modules/registers/pages/CategoryRegistersList.vue');
const RegisterList = () => import('@/modules/registers/pages/RegisterList.vue');

const getRegistersModule = () => import('@/modules/registers/registers-store');
const importRegistersStore = () =>
    getRegistersModule().then((storeModule) => {
        if (!storeAsync().hasModule('registers')) storeAsync().registerModule('registers', storeModule.default);
        else return;
    });

export default [
    {
        path: '',
        component: Layout,
        meta: { auth: true },
        children: [
            {
                name: 'registersConfig',
                path: '/registers-list/:registersTypeId',
                component: CategoryRegistersList,
                meta: {
                    auth: true,
                    permission: Permissions.values.registersConfigRead,
                },
                beforeEnter: (to, from, next) => {
                    importRegistersStore().then(() => {
                        next();
                    });
                },
            },
            {
                name: 'register',
                path: '/register/:registerId',
                component: RegisterList,
                meta: {
                    auth: true,
                    permission: Permissions.values.registersConfigRead,
                },
                beforeEnter: (to, from, next) => {
                    importRegistersStore().then(() => {
                        next();
                    });
                },
            }            
        ],
    },
];
